<template>
  <div class="errorMessageDiv" v-bind:class="triggered ? 'errorDiv' : ''">
    <slot :trigger="validateValue"></slot>
    <span v-if="triggered" class="errorMessage" v-bind:class="triggered ? 'messageTrigger' : ''">{{ errorMessage }}</span
    ><br />
  </div>
</template>

<script>
export default {
  props: {
    info: { type: Object },
    defaultErrorMessage: {
      type: String,
      default: "",
      //default: "⚠ There is an error",
    },
  },
  data: function () {
    return {
      triggered: false,
      errorMessage: "",
    };
  },
  watch: {
    info() {
      this.validateValue();
    },
  },
  methods: {
    validateValue() {
      if (this.info === null) {
        this.errorMessage = "⚠ Field cannot be empty";
        this.triggered = true;
      } else {
        this.$emit("validation");
        this.errorMessage = this.defaultErrorMessage;
        if (this.errorMessage) {
          this.triggered = true;
        } else this.triggered = false;
      }
    },
  },
};
</script>

<style scoped>
.errorMessageDiv {
  position: relative;
  height: 100%;
}

.errorDiv {
  border: 2px solid red;
}

.errorMessage {
  color: red;
  font-size: 11px;
}

</style>